import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@fleetoperate/shared/authentication/feature-authentication';
// import { ROUTE_SHIPMENT_SEARCH } from '@fleetoperate/shipper/feature-shipment';
import { ShellComponent } from './shell/shell.component';

const routes: Routes = [
  { path: '', component: ShellComponent, canActivate: [AuthGuardService] }
  // { path: '', redirectTo: ROUTE_SHIPMENT_SEARCH, pathMatch: 'full', canActivate: [AuthGuardService]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryShipperFeatureShellRoutingModule {}
